import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button as MuiButton } from "@mui/material";
import Button from "components/Button";
import { ButtonContainer } from "components/CreateWheelPopup/CreateWheelPopup.styled";
import TextView from "components/TextView";
import React from "react";
import { useDispatch } from "react-redux";
import { ASSETS } from "utils/config";
import { openUpgradePopup } from "../../../../redux/reducers/upgradePopup";
import {
  CrownIcon,
  ModalContainer,
  ModalContent,
  ModalHeader,
} from "./Wait.styled";

function AiBuilderUpgradeModal({ isOpen, onClose }) {
  
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose();
  };

  const handleUpgrade = () => {
    onClose();
    dispatch(openUpgradePopup());
  };

  return (
    <Modal open={isOpen}>
      <ModalContainer>
        <ModalHeader>
          <CrownIcon src={ASSETS.Premium} alt="Crown" />
          <TextView
            variant="title"
            style={{ fontSize: "20px", color: "#123051" }}
          >
            Upgrade your Wheel Building Game!
          </TextView>
          <CloseIcon className="close-icon" onClick={handleClose} />
        </ModalHeader>
        <ModalContent>
          <TextView
            variant="subtitle"
            style={{
              textAlign: "left",
              fontWeight: "500",
              fontSize: "15px",
              color: "#0F0F0F",
            }}
          >
            For the cost of a latte, upgrade your subcription level to get
            access to all the best features, referral revenue, and analytics.
            Create Wheel Envy with your decked out iYuga Wheels.
          </TextView>
          <hr />
          <div style={{ height: "20px" }}></div>
          <ButtonContainer>
            <MuiButton
              variant="text"
              sx={{ color: "black", textTransform: "none", width: "90px" }}
              onClick={handleClose}
            >
              Cancel
            </MuiButton>
            <Button primary onClick={handleUpgrade}>
              Upgrade today!
            </Button>
          </ButtonContainer>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
}

export default AiBuilderUpgradeModal;
